import { prompt, type PromptDefinition } from './models';

export const LEASING_MANAGER_PROMPTS = [
    prompt(
        'Assess value & use',
        'What leasable areas and permitted uses are documented for this building?',
        'Which buildings have available leasing-area or permitted-use information gaps?'
    ),
    prompt(
        'Assess value & use',
        'What lease expiries and option dates are documented for this building?',
        'Which buildings have the nearest documented lease expiries or option dates?'
    ),
    prompt(
        'Assess value & use',
        "Which tenant requirements are recorded for this building's spaces?",
        'Compare documented tenant requirements across my buildings.'
    ),
    prompt(
        'Assess value & use',
        'Find leasing schedules for this building relating to…',
        'Find leasing schedules across my buildings relating to…',
        'prefill'
    ),
    prompt(
        'Assess value & use',
        'What fit-out or occupancy constraints are documented for this building?',
        'Which buildings have fit-out or occupancy constraints affecting leasing readiness?'
    ),
    prompt(
        'Assess value & use',
        "What incentives or landlord obligations appear in this building's lease documents?",
        'Compare documented incentives and landlord obligations across my buildings.'
    ),
    prompt(
        'Assess value & use',
        'Which marketing claims about this building need supporting documents?',
        'Which buildings have leasing claims without supporting evidence?'
    ),
    prompt(
        'Assess value & use',
        'Find lease clauses for this building covering…',
        'Find lease clauses across my buildings covering…',
        'prefill'
    ),
    prompt(
        'Assess value & use',
        'What tenant handover requirements are recorded for this building?',
        'Which buildings have outstanding tenant handover requirements?'
    ),
    prompt(
        'Assess value & use',
        "Where do this building's tenancy schedule and lease documents differ?",
        'Which buildings have discrepancies between tenancy schedules and lease documents?'
    ),
    prompt(
        'Assess value & use',
        'What questions should I resolve before offering space in this building?',
        'Which buildings have unresolved information gaps affecting leasing offers?'
    ),
    prompt(
        'Assess value & use',
        'Prepare a leasing-information summary for this building focused on…',
        'Compare leasing information across my buildings focused on…',
        'prefill'
    ),
] as const satisfies readonly PromptDefinition[];
